import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  ServiceTicketArrangedCallback,
  ServiceTicketBoilerSerialErrors,
  ServiceTicketCallType,
  ServiceTicketErrorDetails,
  ServiceTicketRoutingProvider,
} from './service-ticket.model';
import { ErrorDatabaseResponse, InstallationItem, ViError } from '../../../projects/client';

export namespace ServiceTicketActions {
  export const navigation = createActionGroup({
    source: '[SERVICE TICKET] navigation',
    events: {
      openCallPage: emptyProps(),
      openArticlesPage: emptyProps(),

      navigateBackToCreatePage: emptyProps(),

      close: emptyProps(),
      reset: emptyProps(),
    },
  });

  // Page Create

  export const updateSelectedErrorCodes = createActionGroup({
    source: '[SERVICE TICKET] updateSelectedErrorCodes',
    events: {
      attempt: props<{
        errorCodes: string[];
        otherErrorSelected: boolean;
      }>(),
    },
  });

  export const updateNoErrorCodeSelection = createActionGroup({
    source: '[SERVICE TICKET] updateNoErrorCodeSelection',
    events: {
      attempt: props<{
        isNoErrorCode: boolean;
      }>(),
    },
  });

  export const updateMarketingName = createActionGroup({
    source: '[SERVICE TICKET] updateMarketingName',
    events: {
      success: props<{
        marketingName: string;
      }>(),
      error: props<{
        error: any;
      }>(),
    },
  });

  export const updateSearchedBoilerSerial = createActionGroup({
    source: '[SERVICE TICKET] updateSearchedBoilerSerial',
    events: {
      attempt: props<{
        boilerSerial: string;
      }>(),
    },
  });

  export const bypassBoilerSerialValidation = createActionGroup({
    source: '[SERVICE TICKET] bypassBoilerSerialValidation',
    events: {
      attempt: emptyProps(),
    },
  });

  export const loadBoilerDeviceDetails = createActionGroup({
    source: '[SERVICE TICKET] loadBoilerDeviceDetails',
    events: {
      attempt: props<{
        boilerSerial: string;
      }>(),
      loadErrors: props<{
        boilerSerial: string;
        installations: InstallationItem[];
        allErrors: ErrorDatabaseResponse;
        errorParams: { serial: string; countryCode: string; langCode: string };
      }>(),
      success: props<{
        errorsDetails: ServiceTicketErrorDetails;
      }>(),
      error: props<{
        error: any;
      }>(),
    },
  });

  export const validateBoilerSerial = createActionGroup({
    source: '[SERVICE TICKET] validateBoilerSerial',
    events: {
      attempt: props<{
        boilerSerial: string;
      }>(),
      success: props<{
        boilerSerial: string;
      }>(),
      gatewaySerialInsteadOfBoilerError: emptyProps(),
      error: props<{
        error: ViError | ServiceTicketBoilerSerialErrors;
      }>(),
    },
  });

  export const updateOtherErrorCode = createActionGroup({
    source: '[SERVICE TICKET] updateOtherErrorCode',
    events: {
      loadDocuments: props<{
        otherErrorCode: string;
      }>(),
      onDocumentsLoaded: emptyProps(),
    },
  });

  // Page Call

  export const updateFeedback = createActionGroup({
    source: '[SERVICE TICKET] updateFeedback',
    events: {
      attempt: props<{
        feedback: string;
      }>(),
      success: emptyProps(),
    },
  });

  export const updatePhoneNumber = createActionGroup({
    source: '[SERVICE TICKET] updatePhoneNumber',
    events: {
      attempt: props<{
        phoneNumber: string;
        isValidPhoneNumber: boolean;
      }>(),
    },
  });

  export const updateCallType = createActionGroup({
    source: '[SERVICE TICKET] updateCallType',
    events: {
      attempt: props<{
        callType: ServiceTicketCallType;
      }>(),
    },
  });

  export const requestWaitingTime = createActionGroup({
    source: '[SERVICE TICKET] requestWaitingTime',
    events: {
      attempt: props<{
        callType: ServiceTicketCallType;
      }>(),
      success: props<{
        callType: ServiceTicketCallType;
        waitTime: any;
      }>(),
      error: props<{
        error: any;
      }>(),
    },
  });

  export const routingProviderRequest = createActionGroup({
    source: '[SERVICE TICKET] routingProviderRequest',
    events: {
      attempt: props<{
        boilerSerial: string;
      }>(),
      success: props<{
        routingProvider: ServiceTicketRoutingProvider;
      }>(),
      error: props<{
        error: ViError;
      }>(),
    },
  });

  export const callNowRequest = createActionGroup({
    source: '[SERVICE TICKET] callNowRequest',
    events: {
      attempt: emptyProps(),
      success: props<{
        acdNumber: string;
      }>(),
      error: props<{
        error: any;
      }>(),
    },
  });

  export const callNowTimeExpired = createActionGroup({
    source: '[SERVICE TICKET] callNowTimeExpired',
    events: {
      attempt: emptyProps(),
    },
  });

  export const arrangedCallbackRequest = createActionGroup({
    source: '[SERVICE TICKET] arrangedCallbackRequest',
    events: {
      attempt: emptyProps(),
      success: props<{
        arrangedCallback: ServiceTicketArrangedCallback;
      }>(),
      error: props<{
        error: any;
      }>(),
    },
  });

  export const removeCachedCallback = createActionGroup({
    source: '[SERVICE TICKET] removeCachedCallback',
    events: {
      attempt: props<{
        id: string;
      }>(),
    },
  });

  export const loadCachedCallbacks = createActionGroup({
    source: '[SERVICE TICKET] loadCachedCallbacks',
    events: {
      attempt: emptyProps(),
      success: props<{
        cachedCallbacks: ServiceTicketArrangedCallback[];
      }>(),
      error: emptyProps(),
    },
  });

  export const setSelectedArticle = createActionGroup({
    source: '[SERVICE TICKET] setSelectedArticle',
    events: {
      attempt: props<{
        id: string;
      }>(),
    },
  });

  export const rateSelectedArticle = createActionGroup({
    source: '[SERVICE TICKET] rateSelectedArticle',
    events: {
      attempt: props<{
        isPositive: boolean;
      }>(),
      success: emptyProps(),
      error: emptyProps(),
    },
  });
}
